import "./App.css";
import ScavengerHunt from "./components/ScavengerHunt";

function App() {
  return (
    <div className="App">
      <ScavengerHunt />
    </div>
  );
}

export default App;
